// extracted by mini-css-extract-plugin
export default {"ldsSpinner":"spinner_ldsSpinner__r2sfo"};